import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { useQueryClient } from "@tanstack/react-query";
import { useWindowSize } from "../../../../../Helpers";
import Button from "@components/Button";
import "./style.scss";
import LinearGradientProgressBar from "@components/LinearGradientProgressBar";
import StickyButton from "../../../../../components/StickyButton";
import PagesHeader from "@components/PagesHeader";
import StickyContent from "@components/StickyContent";
import BrandLogo from "@components/BrandLogo";
import { useTransition } from "@react-spring/web";
import CorrectAnswerPopup from "@components/CorrectAnswerPopup/CorrectAnswerPopup";
import DOMPurify from "dompurify";
import pinDefault from "./img/pin.svg";
import pinClicked from "./img/pin-clicked.svg";

export default function Meet({
  currentQuestion,
  setCurrentQuestion,
  setAnswers,
  answers,
  sendAnswers,
}) {
  const { ident } = useParams();
  const { width } = useWindowSize();
  const queryClient = useQueryClient();
  const gameQuestionsQuery = queryClient.getQueryData([
    "game-questions",
    ident,
  ]);
  const XGA = width >= 1020;
  const [selected, setSelected] = useState(0);
  const [tempAnswers, setTempAnswers] = useState([]);
  const [selectedAnswerCopy, setSelectedAnswerCopy] = useState("");
  const [selectedAnswerCopyTitle, setSelectedAnswerCopyTitle] = useState("");
  const [selectedAnswerCopySub, setSelectedAnswerCopySub] = useState("");
  const [popupOpen, setPopupOpen] = useState(false);
  const [, setPopup] = useState(null);

  const [pinSources, setPinSources] = useState(
    gameQuestionsQuery.content[currentQuestion]?.answers.map(() => pinDefault)
  );

  const handleAddPath = (index) => {
    console.log("handleAddPath started ⌛");
    let answerIdent =
      gameQuestionsQuery.content[currentQuestion]?.answers[index].ident;
    let newTemp = tempAnswers;
    setSelectedAnswerCopy(
      gameQuestionsQuery.content[currentQuestion]?.answers[index].copy
    );
    setSelectedAnswerCopyTitle(
      gameQuestionsQuery.content[currentQuestion]?.answers[index].copyTitle
    );
    setSelectedAnswerCopySub(
      gameQuestionsQuery.content[currentQuestion]?.answers[index].copySub
    );
    if (newTemp.includes(answerIdent)) return;
    newTemp.push(answerIdent);

    const updatedSources = [...pinSources];
    updatedSources[index] = pinClicked;
    setPinSources(updatedSources);

    console.log("newTemp ➡️ ", newTemp);
    setTempAnswers([...newTemp]);
    setSelected(1);
  };

  const openPopup = () => {
    if (popupOpen) {
      setPopupOpen(false);
      setTimeout(() => {
        setPopupOpen(true);
      }, 500);
    } else {
      setPopupOpen(true);
    }
  };

  const transitionPopup = useTransition(popupOpen, {
    from: {
      opacity: 0,
      scale: 0.96,
    },
    enter: {
      opacity: 1,
      scale: 1,
    },
    leave: {
      opacity: 0,
      scale: 0,
    },
    config: {
      duration: 200,
    },
  });

  useEffect(() => {
    if (popupOpen) {
      const timeout = setTimeout(() => {
        setPopupOpen(false);
      }, 10000);

      return () => {
        clearTimeout(timeout);
      };
    }
  }, [popupOpen]);

  function handleNextButtonClick() {
    setSelected(0);
    setTempAnswers([]);
    setPopupOpen(false);
    setAnswers((prev) => [
      ...prev,
      {
        question_ident: `q${currentQuestion}`,
        answer_ident: "",
      },
    ]);
    setCurrentQuestion((prev) =>
      prev <= gameQuestionsQuery.content.length - 1 ? ++prev : prev
    );
  }

  const handleClosePopup = () => {
    setPopupOpen(false);
  };

  const renderBottomCopyPopup = () =>
    transitionPopup((style, item) =>
      item ? (
        <CorrectAnswerPopup
          style="meet-copy"
          attributes={{ popper: {} }}
          setPopup={setPopup}
          handleClosePopup={handleClosePopup}
          styles={{
            position: "absolute",
            zIndex: 300,
            ...style,
          }}
          copyTitle={selectedAnswerCopyTitle}
          copy={selectedAnswerCopy}
          CopySub={selectedAnswerCopySub}
        />
      ) : null,
    );

  console.log(answers);

  return (
    <section className={`game-page meet-mechanics ${ident}`}>
      <div>
        <PagesHeader back>
          <p
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(gameQuestionsQuery?.title),
            }}
          ></p>
        </PagesHeader>
        <div className="main-game-wrppaer">
          <div className="desktop-wrapper">
            {/* {!XGA && (
              <div className="upper-section">
                <LinearGradientProgressBar
                  value={
                    tempAnswers.length /
                    gameQuestionsQuery.content[currentQuestion]?.answers.length
                  }
                />
              </div>
            )} */}
            <div className="game-question">
              {gameQuestionsQuery.content[currentQuestion].header && (
                <p
                  className="question-header"
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(gameQuestionsQuery.content[currentQuestion].header),
                  }}
                />
              )}
              <div className="how-to-box">
                <h2
                  className="question"
                  dangerouslySetInnerHTML={{
                    __html:
                      DOMPurify.sanitize(gameQuestionsQuery.content[currentQuestion].question),
                  }}
                />
              </div>
            </div>
          </div>
          <div className="side-img">
            <div
              className="desktop-background desktop-path"
              style={
                width < XGA
                  ? {}
                  : {
                      backgroundImage: `url(${gameQuestionsQuery.content[currentQuestion]?.desktopImg})`,
                    }
              }
            >
              {!XGA && (
                <div className="image">
                  <img
                    src={gameQuestionsQuery.content[currentQuestion]?.mobileImg}
                    alt=""
                  />
                  {gameQuestionsQuery.content[currentQuestion]?.answers.map(
                    (element, index) => (
                      <React.Fragment key={index}>
                        <div
                          style={{
                            position: "absolute",
                            top: element.clipPathMobile.top,
                            left: element.clipPathMobile.left,
                          }}
                          className={`pin-svg ${
                            tempAnswers.includes(element.ident)
                              ? "selected"
                              : ""
                          }`}
                          key={index}
                          onClick={() => {
                            handleAddPath(index);
                            openPopup();
                          }}
                        >
                          <img
                            className="pin-svg"
                            src={pinSources[index]}
                            alt="Pin"
                          />
                        </div>
                        <div
                          style={{
                            clipPath: element.clipPathMobile,
                            backgroundImage: `url(${gameQuestionsQuery.content[currentQuestion]?.mobileImg})`,
                          }}
                          className="inner-frag"
                        ></div>
                      </React.Fragment>
                    )
                  )}
                  {renderBottomCopyPopup()}
                </div>
              )}
              {XGA &&
                gameQuestionsQuery.content[currentQuestion]?.answers.map(
                  (element, index) => (
                    <React.Fragment key={index}>
                      <div
                        style={{
                          position: "absolute",
                          top: element.clipPathDesktop.top,
                          left: element.clipPathDesktop.left,
                        }}
                        className={`pin-svg ${
                          tempAnswers.includes(element.ident) ? "selected" : ""
                        }`}
                        key={index}
                        onClick={() => {
                          handleAddPath(index);
                          openPopup();
                        }}
                      >
                        <img
                          className="pin-svg"
                          src={pinSources[index]}
                          alt="Pin"
                        />
                      </div>
                      <div
                        style={{
                          clipPath: element.clipPathDesktop,
                          backgroundImage: `url(${gameQuestionsQuery.content[currentQuestion]?.desktopImg})`,
                        }}
                        className="inner-frag"
                      ></div>
                    </React.Fragment>
                  )
                )}
              {XGA && renderBottomCopyPopup()}
            </div>
            <BrandLogo brands={gameQuestionsQuery?.brands} />
            {XGA && (
              <StickyButton
                disabled={
                  tempAnswers.length !==
                  gameQuestionsQuery.content[currentQuestion]?.answers.length
                }
                action={handleNextButtonClick}
              >
                Nächste
              </StickyButton>
            )}
          </div>
        </div>
      </div>

      {!XGA && (
        <StickyContent>
          <div className="desktop-buttons">
            <Button
              disabled={
                tempAnswers.length !==
                gameQuestionsQuery.content[currentQuestion]?.answers.length
              }
              action={handleNextButtonClick}
            >
              Nächste
            </Button>
          </div>
        </StickyContent>
      )}
    </section>
  );
}
